<script lang="ts" context="module">
  export type ChatTab = "chat" | "reengage" | "winback";
</script>

<script lang="ts">
  import { translate } from "lib";

  // Currently selected tab. Bound by the parent screen so it owns the state.
  export let selectedTab: ChatTab = "chat";

  // `labelKey` is a translate() dictionary key, resolved at render time so the
  // tab names follow the active language (en/sr).
  const tabs: Array<{ id: ChatTab; labelKey: string }> = [
    { id: "chat", labelKey: "CHAT" },
    { id: "reengage", labelKey: "REENGAGE" },
    { id: "winback", labelKey: "WINBACK" },
  ];
</script>

<div
  class="flex w-full border-b border-slate-300 dark:border-zinc-700 bg-white dark:bg-zinc-800"
>
  {#each tabs as tab (tab.id)}
    <button
      type="button"
      class={`flex-1 py-3 text-sm font-medium text-center transition-colors ${
        selectedTab === tab.id
          ? "text-teal-600 dark:text-teal-400 border-b-2 border-teal-600 dark:border-teal-400"
          : "text-slate-500 dark:text-slate-400 border-b-2 border-transparent"
      }`}
      on:click={() => (selectedTab = tab.id)}
    >
      {translate(tab.labelKey)}
    </button>
  {/each}
</div>
